import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {
  MYPAGE_PROFILE,
  MYPAGE_ACCOUNT,
  USER_HISTORIES,
  USER_SKILLS,
  USER_PAYMENT,
  USER_WITHHOLDINGS,
} from '../routing';
import T from 'i18n-react';

const routes = [
  { name: T.translate('user.titles.profile'), path: MYPAGE_PROFILE },
  { name: T.translate('user.titles.account'), path: MYPAGE_ACCOUNT },
  { name: T.translate('user.titles.histories'), path: USER_HISTORIES },
  { name: T.translate('user.titles.skills'), path: USER_SKILLS },
  { name: T.translate('user.titles.payments'), path: USER_PAYMENT },
  {
    name: T.translate('user.titles.withholding_slips'),
    path: USER_WITHHOLDINGS,
  },
];

const CustomizedTabs = withStyles({
  root: {
    flex: 3,
  },
  indicator: {
    backgroundColor: '#FF5910',
    left: 0,
    width: 4,
  },
})(Tabs);

const CustomizedTab = withStyles((theme) => ({
  root: {
    maxWidth: 180,
    '&:hover': {
      textDecoration: 'none',
    },
  },
  wrapper: {
    marginLeft: 6,

    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'start',
    },
  },
}))(Tab);

const UserMenu = () => {
  const [currentTab, setCurrentTab] = React.useState(0);

  React.useEffect(() => {
    routes.forEach((route, index) => {
      if (window.location.pathname === route.path) {
        setCurrentTab(index);
      }
    });
  }, []);

  return (
    <CustomizedTabs
      orientation="vertical"
      centered={false}
      value={currentTab}
      onChange={(_, value) => setCurrentTab(value)}
    >
      {routes.map((route) => (
        <CustomizedTab
          key={route.path}
          label={route.name}
          href={window.location.pathname === route.path ? null : route.path}
        />
      ))}
    </CustomizedTabs>
  );
};

export default UserMenu;
